import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "m-2 mt-4 mb-4 p-text-center" }
const _hoisted_5 = { class: "p-mt-2" }
const _hoisted_6 = { class: "p-text-center" }
const _hoisted_7 = { class: "table table-bordered table-hover" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("tr", { style: {"background-color":"#004C97","color":"#fff"} }, [
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "DATE"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "ACCOUNT TITLE AND EXPLANATION"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "SOURCE"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "DEBIT"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "CREDIT"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "BALANCE")
], -1)
const _hoisted_9 = { style: {"background-color":"#ccc"} }
const _hoisted_10 = {
  class: "p-p-1",
  colspan: "6"
}
const _hoisted_11 = { class: "p-p-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "p-p-1" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", { class: "p-p-1" }, null, -1)
const _hoisted_14 = { class: "p-p-1" }
const _hoisted_15 = { class: "p-p-1" }
const _hoisted_16 = { class: "p-p-1" }
const _hoisted_17 = { class: "p-p-1" }
const _hoisted_18 = { class: "p-p-1" }
const _hoisted_19 = { class: "p-p-1" }
const _hoisted_20 = { class: "p-p-1" }
const _hoisted_21 = { class: "p-p-1" }
const _hoisted_22 = { class: "p-p-1" }
const _hoisted_23 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-search",
  style: {"font-size":"1.2rem"}
}, null, -1)
const _hoisted_25 = { class: "p-field" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Filter Date", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h5", null, "OR", -1)
const _hoisted_28 = { class: "p-grid" }
const _hoisted_29 = { class: "p-col" }
const _hoisted_30 = { class: "p-field" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "from" }, "Date From", -1)
const _hoisted_32 = { class: "p-col" }
const _hoisted_33 = { class: "p-field" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { for: "to" }, "Date To", -1)
const _hoisted_35 = { class: "p-grid" }
const _hoisted_36 = { class: "p-col" }
const _hoisted_37 = { class: "p-field" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Filter Type", -1)
const _hoisted_39 = { class: "p-col" }
const _hoisted_40 = { class: "p-field" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Branch", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text p-p-1"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Button, {
              icon: "pi pi-search",
              class: "p-button-success px-4",
              onClick: _ctx.openDialog
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              icon: "pi pi-print",
              class: "p-button-primary px-4",
              onClick: _ctx.openDialog
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.storeName) + " General Ledger", 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.resultTitle), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.searchFilters.reportType), 1),
        _createElementVNode("table", _hoisted_7, [
          _hoisted_8,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ledgerTransactions, (t) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: t }, [
              _createElementVNode("tr", _hoisted_9, [
                _createElementVNode("td", _hoisted_10, _toDisplayString(t.accountTitle) + " (" + _toDisplayString(t.accountCode) + ")", 1)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_11, "Previous From " + _toDisplayString(_ctx.previousDate), 1),
                _hoisted_12,
                _hoisted_13,
                _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.formatAmount(_ctx.previousDebit(t.accountID))), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.formatAmount(_ctx.previousCredit(t.accountID))), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.checkForCredit(_ctx.previousBalance(t.accountID))), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(t.transactions, (l) => {
                return (_openBlock(), _createElementBlock("tr", { key: l }, [
                  _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.formatDate(l.date)) + " / " + _toDisplayString(_ctx.formatTime(l.date)), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(l.narration), 1),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(l.source), 1),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.formatAmount(l.debit)), 1),
                  _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.formatAmount(l.credit)), 1),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.checkForCredit(l.balance)), 1)
                ]))
              }), 128))
            ], 64))
          }), 128))
        ])
      ]),
      _createVNode(_component_Dialog, {
        visible: _ctx.productDialog,
        "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.productDialog) = $event)),
        style: { width: '50vw' },
        maximizable: true,
        position: "top",
        class: "p-fluid"
      }, {
        header: _withCtx(() => [
          _createElementVNode("h5", _hoisted_23, [
            _hoisted_24,
            _createTextVNode(" " + _toDisplayString(_ctx.dialogTitle), 1)
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            type: "submit",
            label: "Search",
            icon: "pi pi-search",
            class: "p-button-primary",
            onClick: _ctx.loadList
          }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.searchFilters.filterType,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchFilters.filterType) = $event)),
              options: _ctx.filterDates,
              filter: true,
              optionLabel: "key",
              optionValue: "value"
            }, null, 8, ["modelValue", "options"])
          ]),
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "from",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchFilters.date1) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.searchFilters.date1]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "to",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchFilters.date2) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.searchFilters.date2]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.searchFilters.reportType,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchFilters.reportType) = $event)),
                  options: _ctx.reportTypes,
                  filter: true,
                  optionLabel: "name",
                  optionValue: "name"
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.searchFilters.storeID,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchFilters.storeID) = $event)),
                  options: _ctx.filterBranch,
                  filter: true,
                  optionLabel: "name",
                  optionValue: "id"
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ]))
}